/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GroupWithResults } from './GroupWithResults';
import {
    GroupWithResultsFromJSON,
    GroupWithResultsFromJSONTyped,
    GroupWithResultsToJSON,
    GroupWithResultsToJSONTyped,
} from './GroupWithResults';
import type { StageType } from './StageType';
import {
    StageTypeFromJSON,
    StageTypeFromJSONTyped,
    StageTypeToJSON,
    StageTypeToJSONTyped,
} from './StageType';

/**
 * 
 * @export
 * @interface StageWithResults
 */
export interface StageWithResults {
    /**
     * 
     * @type {string}
     * @memberof StageWithResults
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof StageWithResults
     */
    name?: string;
    /**
     * 
     * @type {StageType}
     * @memberof StageWithResults
     */
    stageType?: StageType;
    /**
     * 
     * @type {number}
     * @memberof StageWithResults
     */
    orderIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof StageWithResults
     */
    bracket?: string;
    /**
     * 
     * @type {Array<GroupWithResults>}
     * @memberof StageWithResults
     */
    groups?: Array<GroupWithResults>;
}



/**
 * Check if a given object implements the StageWithResults interface.
 */
export function instanceOfStageWithResults(value: object): value is StageWithResults {
    return true;
}

export function StageWithResultsFromJSON(json: any): StageWithResults {
    return StageWithResultsFromJSONTyped(json, false);
}

export function StageWithResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StageWithResults {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'stageType': json['stageType'] == null ? undefined : StageTypeFromJSON(json['stageType']),
        'orderIndex': json['orderIndex'] == null ? undefined : json['orderIndex'],
        'bracket': json['bracket'] == null ? undefined : json['bracket'],
        'groups': json['groups'] == null ? undefined : ((json['groups'] as Array<any>).map(GroupWithResultsFromJSON)),
    };
}

export function StageWithResultsToJSON(json: any): StageWithResults {
    return StageWithResultsToJSONTyped(json, false);
}

export function StageWithResultsToJSONTyped(value?: StageWithResults | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'stageType': StageTypeToJSON(value['stageType']),
        'orderIndex': value['orderIndex'],
        'bracket': value['bracket'],
        'groups': value['groups'] == null ? undefined : ((value['groups'] as Array<any>).map(GroupWithResultsToJSON)),
    };
}

